define('viewmodels/ActionTracker/ActionPlanManagement',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'services/AppRoutes', 'viewmodels/GeneralSettings', 'viewmodels/header', 'viewmodels/ActionTracker/ActionItemDashboard'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, AppRoutes, ObjGeneralSettings, header, ActionItemDashboardVM) {

        var vmActionPM = {
            activate: function () {
            },
          
            attached: attached,
            detached: detached,
            header: header,
            appsecurity: appsecurity,
            AppRoutes: AppRoutes,
            logger: logger,
            utils: utils,
            ResponseMoveArray: ko.observableArray([]),
            //ActionPlanDetailsVM: ActionPlanDetailsVM,
            BulkAssignOwner: BulkAssignOwner,
            BulkAssignReviewer: BulkAssignReviewer,
            CreateActionPlan: CreateActionPlan,
            ActionPlanModelList: ko.observableArray([]),
            AssignPlanOwners: AssignPlanOwners,
            AssignPlanReviewers: AssignPlanReviewers,
            CloseCreateActionPlanPopUp: CloseCreateActionPlanPopUp,
            ActionPlanTitle: ko.observable(),
            ActionPlanDescription: ko.observable(),
            ActionPlanPriorityList: ko.observableArray([]),
            SelectedPriorityLevel: ko.observable(),
            APStartDate: ko.observable(),
            APEndDate: ko.observable(),
            ActionStartDate: ko.observable(),
            ActionEndDate: ko.observable(),
            RolesDrpDwnList: ko.observableArray(), 
            RoleValue: ko.observable(),
            RolesDrpDwnReviewerList: ko.observableArray(),
            RoleValueReviewer: ko.observable(),

            DisableActionPlanSaveBtn: ko.observable(false),
            SaveActionPlan: SaveActionPlan,
            SaveActionPlanOwner: SaveActionPlanOwner,
            ActionPlanOwnerList: ko.observableArray(),
            SaveActionPlanReviewer: SaveActionPlanReviewer,
            CloseAssignPlanPopUp: CloseAssignPlanPopUp,
            ViewActionPlan: ViewActionPlan,
            SelectAllActionItems: SelectAllActionItems,
            DeleteActionPlan: DeleteActionPlan,
            SelectAllActionPlanOwners: SelectAllActionPlanOwners,
            ActionPlanId: ko.observable(),
            SelectAllActionPlanReviewer: SelectAllActionPlanReviewer,
            ActionPlanReviewerList: ko.observableArray(),
            SelectedOwnerItems: ko.observableArray(),
            SelectedManagerItems: ko.observableArray(),
            BulkUserList: ko.observableArray(),
            AssignPlanReviewerSingle: AssignPlanReviewerSingle,
            AssignPlanOwnerSingle: AssignPlanOwnerSingle,

        };
        return vmActionPM;


        function attached() {
            try {
               
                GetAllActionPlans();
                $('#tblActionPlan').DataTable().state.clear();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
            finally {
 
            }
        }

        function detached() {
            try {
       
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function BulkAssignOwner() {
            try {
                $('#valErrorBulkOwner').hide();
                vmActionPM.SelectedOwnerItems([]);

                ko.utils.arrayForEach(vmActionPM.ActionPlanModelList(), function (listItem) {
                    if (listItem.IS_SELECTED()) {
                        vmActionPM.SelectedOwnerItems.push(listItem);
                    }
                });
                $("#AssignOwnerPopUp").modal('show');
                if (vmActionPM.SelectedOwnerItems().length < 1) {
                    $('#valErrorBulkOwner').show();
                    $('#tblActionPlanDivOwner').hide();
                    $('#SavePlanOwners').hide();
                    $('#valErrorBulkOwner').html('Please select atleast one plan to assign Owners');
                } else {
                    $('#valErrorBulkOwner').hide();
                    $('#tblActionPlanDivOwner').show();
                    $('#SavePlanOwners').show();
                    $('#valErrorBulkOwner').html('');
                    GetAllUserRole();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BulkAssignOwner() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        function BulkAssignReviewer() {
            try {
                $('#valErrorBulkManager').hide();
                vmActionPM.SelectedManagerItems([]);

                ko.utils.arrayForEach(vmActionPM.ActionPlanModelList(), function (listItem) {
                    if (listItem.IS_SELECTED()) {
                        vmActionPM.SelectedManagerItems.push(listItem);
                    }
                });
                $("#AssignReviewerPopUp").modal('show');
                if (vmActionPM.SelectedManagerItems().length < 1) {
                    $('#valErrorBulkManager').show();
                    $('#tblActionPlanDivManager').hide();
                    $('#SavePlanManager').hide();
                    $('#valErrorBulkManager').html('Please select atleast one plan to assign Managers');
                }
                else {
                    $('#valErrorBulkManager').hide();
                    $('#tblActionPlanDivManager').show();
                    $('#SavePlanManager').show();
                    $('#valErrorBulkManager').html('');
                    GetAllUserRole();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BulkAssignReviewer() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        function CreateActionPlan() {
            try {
                $('#valError').hide();
                $("#APStartDate").datepicker();
                $("#APEndDate").datepicker();
                document.getElementById("txtActionPlanTitle").value = "";
                document.getElementById("txtActionPlanDescription").value = "";
                document.getElementById("ddlActionPlanPriority").value = "";

                var MockedPriorityList = [
                    {
                        "PriorityId": 1,
                        "PriorityLevel": "High"
                    },
                    {
                        "PriorityId": 2,
                        "PriorityLevel": "Medium"
                    },
                    {
                        "PriorityId": 3,
                        "PriorityLevel": "Low"
                    }
                    ];

                var MappedPriorityList = $.map(MockedPriorityList, function (result) {
                    return new APPriorityModel(result);
                });

                vmActionPM.ActionPlanPriorityList(MappedPriorityList);

                $("#CreateActionPlanPop").modal('show');
                //GetAllUserRole();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateActionPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        
        function CloseCreateActionPlanPopUp() {
            try {
                $("#CreateActionPlanPop").modal('hide');           
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in CloseCreateActionPlanPopUp() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function CloseAssignPlanPopUp() {
            try {
                $("#AssignOwnerPopUp").modal('hide');
                $("#AssignReviewerPopUp").modal('hide');
                vmActionPM.SelectedOwnerItems([]);
                vmActionPM.SelectedManagerItems([]);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in CloseAssignPlanPopUp() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        
        function AssignPlanOwners(data) {
            try {
                $("#AssignOwnerPopUp").modal('show');
                vmActionPM.ActionPlanId(data.ActionPlanId());
                GetAllUserRole();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateActionPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        function AssignPlanOwnerSingle(data) {
            try {
                $("#AssignOwnerPopUp").modal('show');
                vmActionPM.ActionPlanId(data.ActionPlanId());
                GetAllUserRoleForPlan();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateActionPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function SaveActionPlanOwner() {
            try {
                var isListEmpty = true;
                for (var i = 0; i < vmActionPM.ActionPlanOwnerList().length; i++) {
                    if (vmActionPM.ActionPlanOwnerList()[i].IS_SELECTED() == true) {
                        isListEmpty = false;
                        break;
                    }
                }
                $('#valErrorOwner').hide();
                if (isListEmpty == true) {
                    $('#valErrorOwner').show();
                    $('#valErrorOwner').html('Please select atleast one plan owner');
                }
                else {
                    if (vmActionPM.SelectedOwnerItems().length < 1) {
                        $('#loadingImgAssignOwner').show();
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        return $.ajax({
                            url: "/api/ActionPlan/SaveActionPlanUsers",
                            type: "POST",
                            headers: headers,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify($.map(vmActionPM.ActionPlanOwnerList(), function (result) {
                                if (result.IS_SELECTED() == true) {
                                    return { ActionPlanId: vmActionPM.ActionPlanId(), RoleId: result.PlanOwnerId(), RoleType: "AP_ONR", UserId: result.UserId() };
                                }
                            }))
                        })
                            .success(function (jsonResult, error) {
                                if (jsonResult != undefined && jsonResult != -1) {
                                    logger.logSuccess('Updated Successfully ', 'Success', system.getModuleId(vmActionPM), true);
                                    $('#loadingImgAssignOwner').hide();
                                    $("#AssignOwnerPopUp").modal('hide');
                                    GetAllActionPlans();
                                } else {
                                    $('#loadingImgAssignOwner').hide();
                                    logger.logError('Some Error occured while adding details.', 'Error', system.getModuleId(vmActionPM), true);
                                }
                            })
                            .fail(function (jsonResult, error) {
                                $('#loadingImgAssignOwner').hide();
                                logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                            });
                    } else {
                        vmActionPM.BulkUserList([]);

                        for (var i = 0; i < vmActionPM.SelectedOwnerItems().length; i++) {
                            for (var j = 0; j < vmActionPM.ActionPlanOwnerList().length ; j++) {

                                if (vmActionPM.ActionPlanOwnerList()[j].IS_SELECTED() == true) {
                                    vmActionPM.BulkUserList.push(new BulkUserModel({
                                        ActionPlanId: vmActionPM.SelectedOwnerItems()[i].ActionPlanId(),
                                        RoleId: vmActionPM.ActionPlanOwnerList()[j].PlanOwnerId(),
                                        RoleType: "AP_ONR",
                                        UserId: vmActionPM.ActionPlanOwnerList()[j].UserId()
                                    }));
                                }
                            }
                        }
                        $('#loadingImgAssignOwner').show();
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        return $.ajax({
                            url: "/api/ActionPlan/SaveActionPlanUsers",
                            type: "POST",
                            headers: headers,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify($.map(vmActionPM.BulkUserList(), function (result) {
                                return { ActionPlanId: result.ActionPlanId(), RoleId: result.RoleId(), RoleType: "AP_ONR", UserId: result.UserId() };
                            }))
                        })
                            .success(function (jsonResult, error) {
                                if (jsonResult != undefined && jsonResult != -1) {
                                    logger.logSuccess('Updated Successfully ', 'Success', system.getModuleId(vmActionPM), true);
                                    $('#loadingImgAssignOwner').hide();
                                    $("#AssignOwnerPopUp").modal('hide');
                                    GetAllActionPlans();
                                } else {
                                    $('#loadingImgAssignOwner').hide();
                                    logger.logError('Some Error occured while adding details.', 'Error', system.getModuleId(vmActionPM), true);
                                }
                                vmActionPM.BulkUserList([]);
                            })
                            .fail(function (jsonResult, error) {
                                $('#loadingImgAssignOwner').hide();
                                vmActionPM.BulkUserList([]);
                                logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                            });
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveActionPlanOwner() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
       
        function AssignPlanReviewers() {
            try {
                $("#AssignReviewerPopUp").modal('show');
                GetAllUserRole();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssignPlanReviewers() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        function AssignPlanReviewerSingle(data) {
            try {
                $("#AssignReviewerPopUp").modal('show');
                vmActionPM.ActionPlanId(data.ActionPlanId());
                GetAllUserRoleForPlan();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssignPlanReviewers() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        
        function SaveActionPlanReviewer() {
            try {
                var isListEmpty = true;
                for (var i = 0; i < vmActionPM.ActionPlanReviewerList().length; i++) {
                    if (vmActionPM.ActionPlanReviewerList()[i].IS_SELECTED() == true) {
                        isListEmpty = false;
                        break;
                    }
                }
                $('#valErrorReviewer').hide();
                if (isListEmpty == true) {
                    $('#valErrorReviewer').show();
                    $('#valErrorReviewer').html('Please select atleast one plan reviewer');
                }
                else {
                    if (vmActionPM.SelectedManagerItems().length < 1) {
                        $('#loadingImgAssignManager').show();
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        return $.ajax({
                            url: "/api/ActionPlan/SaveActionPlanUsers",
                            type: "POST",
                            headers: headers,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify($.map(vmActionPM.ActionPlanReviewerList(), function (result) {
                                if (result.IS_SELECTED() == true) {
                                    return { ActionPlanId: vmActionPM.ActionPlanId(), RoleId: result.PlanOwnerId(), RoleType: "AP_MGR", UserId: result.UserId() };
                                }
                            }))
                        })
                            .success(function (jsonResult, error) {
                                if (jsonResult != undefined && jsonResult != -1) {
                                    logger.logSuccess('Updated Successfully ', 'Success', system.getModuleId(vmActionPM), true);
                                    $('#loadingImgAssignManager').hide();
                                    $("#AssignReviewerPopUp").modal('hide');
                                    GetAllActionPlans();
                                } else {
                                    $('#loadingImgAssignManager').hide();
                                    logger.logError('Some Error occured while adding details.', 'Error', system.getModuleId(vmActionPM), true);
                                }
                            })
                            .fail(function (jsonResult, error) {
                                $('#loadingImgAssignManager').hide();
                                logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                            });
                    } else 
                    {
                        vmActionPM.BulkUserList([]);

                        for (var i = 0; i < vmActionPM.SelectedManagerItems().length; i++) {
                            for (var j = 0; j < vmActionPM.ActionPlanReviewerList().length ; j++) {

                                if (vmActionPM.ActionPlanReviewerList()[j].IS_SELECTED() == true) {
                                        vmActionPM.BulkUserList.push(new BulkUserModel({
                                            ActionPlanId: vmActionPM.SelectedManagerItems()[i].ActionPlanId(), 
                                            RoleId: vmActionPM.ActionPlanReviewerList()[j].PlanOwnerId(),
                                            RoleType: "AP_MGR", 
                                            UserId: vmActionPM.ActionPlanReviewerList()[j].UserId()
                                            }));
                                }
                            }
                        }

                        $('#loadingImgAssignManager').show();
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        return $.ajax({
                            url: "/api/ActionPlan/SaveActionPlanUsers",
                            type: "POST",
                            headers: headers,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify($.map(vmActionPM.BulkUserList(), function (result) {
                                return { ActionPlanId: result.ActionPlanId(), RoleId: result.RoleId(), RoleType: "AP_MGR", UserId: result.UserId() };
                            }))
                        })
                            .success(function (jsonResult, error) {
                                if (jsonResult != undefined && jsonResult != -1) {
                                    logger.logSuccess('Updated Successfully ', 'Success', system.getModuleId(vmActionPM), true);
                                    $('#loadingImgAssignManager').hide();
                                    $("#AssignReviewerPopUp").modal('hide');
                                    GetAllActionPlans();
                                } else {
                                    $('#loadingImgAssignManager').hide();
                                    logger.logError('Some Error occured while adding details.', 'Error', system.getModuleId(vmActionPM), true);
                                }
                                vmActionPM.BulkUserList([]);
                            })
                            .fail(function (jsonResult, error) {
                                $('#loadingImgAssignManager').hide();
                                vmActionPM.BulkUserList([]);
                                logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                            });
                }
                    
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveActionPlanReviewer() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
    }

        function APPriorityModel(item) {
            try {
                var self = this;
                self.PRIORITY_ID = ko.observable(item.PriorityId);
                self.PRIORITY_LEVEL = ko.observable(item.PriorityLevel);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OrgLevelModel() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        
        function SaveActionPlan(data, event) {
            try {
                $('#valError').hide();
                if (data.ActionPlanTitle() == undefined || data.ActionPlanTitle() == "") {
                    $('#valError').show();
                    $('#valError').html('Action plan title is mandatory');
                }
                else {
                    $("#CreateActionPlanPop").modal('hide');
                    $('#loadingImgSavePlan').show();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/ActionPlan/SaveActionPlan",
                        type: "POST",
                        headers: headers,
                        data: { ActionPlanId: -1 ,ActionPlanTitle: vmActionPM.ActionPlanTitle, PlanOwner: $('#RoleDrpDownOwner').val(), PlanReviewer: $('#RoleDrpDownReviewer').val(), ActionPlanDescription: vmActionPM.ActionPlanDescription, ActionPlanPriority: $('#ddlActionPlanPriority').val(), EstimatedStartDate: $('#APStartDate').val(), EstimatedEndDate: $('#APEndDate').val() }
                    })
                        .success(function (jsonResult, error) {
                       
                            if (jsonResult != undefined && jsonResult != -1) {
                                logger.logSuccess('Added Successfully ', 'Success', system.getModuleId(vmActionPM), true);
                                GetAllActionPlans();
                            } else {
                                logger.logError('Some Error occured while adding details.', 'Error', system.getModuleId(vmActionPM), true);
                            }
                            $('#loadingImgSavePlan').hide();
                        })
                        .fail(function (jsonResult, error) {
                            logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                            $('#loadingImgSavePlan').hide();
                        });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveActionPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function GetAllActionPlans() {
            try {
            return $.ajax({
                url: "/api/ActionPlan/GetAllActionPlanList",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, error) {
            if (jsonResult == null) {
                vmActionPM.ActionPlanModelList([]);                
                var object = $('#tblActionPlan').DataTable();
                object.destroy();
                $('#tblActionPlan tbody tr').remove();
                $("#tblActionPlan").DataTable();
            }
            else if (jsonResult.length >= 0) {
                var mappedActionPlanList = $.map(jsonResult, function (result) {
                    var APModelObj = new ActionPlanModel(result);
                    return APModelObj;
                });
                
                vmActionPM.ActionPlanModelList([]);
                var object = $('#tblActionPlan').DataTable();
                object.destroy();
                $('#tblActionPlan tbody tr').remove();
                vmActionPM.ActionPlanModelList(mappedActionPlanList);
                $("#tblActionPlan").DataTable(
                    {
                     stateSave: true
                    },{
                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "order": [],
                            "bSortable": false

                        }]
                    });
            }
            else {
                vmActionPM.ActionPlanModelList([]);
                $('#tblActionPlan').DataTable({
                    "aoColumnDefs": [{
                        "aTargets": [0],
                        "order": [],
                        "bVisible": false

                    },
                                {
                                    "aTargets": [1],
                                    "bSortable": false
                                },
                        {
                            "aTargets": [3],
                            "bSortable": true
                        }
              ]

                });
            } 
            $('#Select_ALL_Action_Plans').prop('checked', false);
            var rows = $("#tblActionPlan").dataTable().fnGetNodes();
            var cells = [];
        })

        .fail(function (jsonnResult, error) {

            logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vmActionPM), true);

        });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllActionPlans() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function SelectAllActionItems(data, event) {
            try {
                ko.utils.arrayForEach(data.ActionPlanModelList(), function (listItem) {
                    listItem.IS_SELECTED(event.currentTarget.checked);
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllActionItems() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        

        function SelectAllActionPlanOwners(data, event) {
            try {
                ko.utils.arrayForEach(data.ActionPlanOwnerList(), function (listItem) {
                    listItem.IS_SELECTED(event.currentTarget.checked);
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllActionPlanOwners() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        
        function SelectAllActionPlanReviewer(data, event) {
            try {
                ko.utils.arrayForEach(data.ActionPlanReviewerList(), function (listItem) {
                    listItem.IS_SELECTED(event.currentTarget.checked);
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllActionPlanReviewer() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function GetAllUserRole() {
            try {
                $.ajax({
                    url: "/api/ActionPlan/GetAllUserRole",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | source: GetAllUserRole() in ActionPlanManagement.js';
                logger.logMessage(msg)
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        var mappedRole = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });
                        
                        var mappedRoleForGridOwner = $.map(jsonResult.Owners, function (result) {
                                return new OwnerReviewerListModel(result);
                        });

                        var mappedRoleForGridRev = $.map(jsonResult.Reviewers, function (result) {
                                return new OwnerReviewerListModel(result);
                        });
                        vmActionPM.ActionPlanOwnerList([]);
                        var object = $('#tblActionPlanOwner').DataTable();
                        object.destroy();
                        $('#tblActionPlanOwner tbody tr').remove();
                        vmActionPM.ActionPlanOwnerList(mappedRoleForGridOwner);

                        $("#tblActionPlanOwner").DataTable(
                            {
                                "aoColumnDefs": [{
                                    "aTargets": [0],
                                    "order": [],
                                    "bSortable": false

                                }]
                            }
                            );


                        vmActionPM.ActionPlanReviewerList([]);
                        var object = $('#tblActionPlanReviewer').DataTable();
                        object.destroy();
                        $('#tblActionPlanReviewer tbody tr').remove();
                        vmActionPM.ActionPlanReviewerList(mappedRoleForGridRev);

                        $("#tblActionPlanReviewer").DataTable(
                            {
                                "aoColumnDefs": [{
                                    "aTargets": [0],
                                    "order": [],
                                    "bSortable": false

                                }]
                            }
                            );
                    }
                    else {
                        vmActionPM.ActionPlanOwnerList([]);
                        vmActionPM.ActionPlanReviewerList([]);
                    }
                }
                catch (e) {
                    var msg = 'exception' + e + ' | source: ajaxSucess() in GetAllUserRole() in ActionPlanManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUserRole() method in ActionPlanManagement.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUserRole() method in ActionPlanManagement.js';
                    logger.logMessage(msg);
                }
            }

        }

        
        function GetAllUserRoleForPlan() {
            try {
                $.ajax({
                    url: "/api/ActionPlan/GetAllUserRoleForPlan",
                    type: "GET",
                    data: { "ActionPlanId": vmActionPM.ActionPlanId() },
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | source: GetAllUserRoleForPlan() in ActionPlanManagement.js';
                logger.logMessage(msg)
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        var mappedRole = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });

                        var mappedRoleForGridOwner = $.map(jsonResult.Owners, function (result) {
                            return new OwnerReviewerListForPlanModel(result);
                        });

                        var mappedRoleForGridRev = $.map(jsonResult.Reviewers, function (result) {
                            return new OwnerReviewerListForPlanModel(result);
                        });
                        vmActionPM.ActionPlanOwnerList([]);
                        var object = $('#tblActionPlanOwner').DataTable();
                        object.destroy();
                        $('#tblActionPlanOwner tbody tr').remove();
                        vmActionPM.ActionPlanOwnerList(mappedRoleForGridOwner);

                        $("#tblActionPlanOwner").DataTable(
                            {
                                "aoColumnDefs": [{
                                    "aTargets": [0],
                                    "order": [],
                                    "bSortable": false

                                }]
                            }
                            );

                        vmActionPM.ActionPlanReviewerList([]);
                        var object = $('#tblActionPlanReviewer').DataTable();
                        object.destroy();
                        $('#tblActionPlanReviewer tbody tr').remove();
                        vmActionPM.ActionPlanReviewerList(mappedRoleForGridRev);

                        $("#tblActionPlanReviewer").DataTable(
                            {
                                "aoColumnDefs": [{
                                    "aTargets": [0],
                                    "order": [],
                                    "bSortable": false

                                }]
                            }
                            );
                    }
                    else {
                        vmActionPM.ActionPlanOwnerList([]);
                        vmActionPM.ActionPlanReviewerList([]);
                    }
                }
                catch (e) {
                    var msg = 'exception' + e + ' | source: ajaxSucess() in GetAllUserRoleForPlan() in ActionPlanManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUserRoleForPlan() method in ActionPlanManagement.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUserRoleForPlan() method in ActionPlanManagement.js';
                    logger.logMessage(msg);
                }
            }

        }

        function ViewActionPlan(data) {
            try {
                vmActionPM.appsecurity.ActionPageType("PlanManagement");
                vmActionPM.ResponseMoveArray(new ResponseMoveModel({ ActionPlanId: data.ActionPlanId(), ActionPlanLabel: data.ActionPlanLabel() }));
                router.navigate("#ActionTracker/ActionPlanDetails", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewActionPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function ResponseMoveModel(item) {
            try {
                var self = this;
                self.ActionPlanId = ko.observable(item.ActionPlanId);
                self.ActionPlanLabel = ko.observable(item.ActionPlanLabel);
                self.IsFromDashboard = ko.observable(false);
                
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }
        function RoleModel(item) {
            try {
                var self = this;
                self.RoleId = ko.observable(item.RoleId);
                self.RoleName = ko.observable($('<div/>').html(item.RoleName).text());
                self.RoleType = ko.observable($('<div/>').html(item.RoleType).text());
                self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: RoleModel() in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function BulkUserModel(item) {
            try {
                var self = this;
                self.ActionPlanId = ko.observable(item.ActionPlanId);
                self.RoleId = ko.observable(item.RoleId);
                self.RoleType = ko.observable($('<div/>').html(item.RoleType).text());
                self.UserId = ko.observable(item.UserId);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BulkUserModel() in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function OwnerReviewerListModel(item) {
            try {
                var self = this;
                self.IS_SELECTED = ko.observable(false);
                self.PlanOwnerId = ko.observable(item.RoleId);
                self.PlanOwnerName = ko.observable($('<div/>').html(item.RoleName).text());
                self.UserType = ko.observable($('<div/>').html(item.RoleType).text());
                self.UserName = ko.observable($('<div/>').html(item.UserName).text());
                self.UserId = ko.observable(item.UserId);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: OwnerReviewerListModel() in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        function OwnerReviewerListForPlanModel(item) {
            try {
                var self = this;
                self.IS_SELECTED = ko.observable(item.IS_SELECTED);
                self.PlanOwnerId = ko.observable(item.RoleId);
                self.PlanOwnerName = ko.observable($('<div/>').html(item.RoleName).text());
                self.UserType = ko.observable($('<div/>').html(item.RoleType).text());
                self.UserName = ko.observable($('<div/>').html(item.UserName).text());
                self.UserId = ko.observable(item.UserId);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: OwnerReviewerListModel() in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }


        function DeleteActionPlan(data, event) {
            try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/ActionPlan/DeleteActionPlan",
                        type: "POST",
                        headers: headers,
                        data: { ActionPlanId: data.ActionPlanId() }
                    })
                        .success(function (jsonResult, error) {
                            if (jsonResult != undefined && jsonResult == 1) {
                                logger.logSuccess('Deleted Successfully ', 'Success', system.getModuleId(vmActionPM), true);
                                GetAllActionPlans();
                            } else {
                                logger.logWarning('Please delete the action items associated to this plan before deleting the plan.', 'Error', system.getModuleId(vmActionPM), true);
                            }

                        })
                        .fail(function (jsonResult, error) {
                            logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                        });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteActionPlan() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

        // Models 
        function ActionPlanModel(item) {
            try {
                var self = this;
                self.IS_SELECTED = ko.observable(false);
                self.ActionPlanId = ko.observable($('<div/>').html(item.ActionPlanId).text());
                self.ActionPlanTitle = ko.observable($('<div/>').html(item.ActionPlanTitle).text());
                self.ActionPlanLabel = ko.observable($('<div/>').html(item.ActionPlanLabel).text());
                self.PlanOwner = ko.observable($('<div/>').html(item.PlanOwner).text());            
                self.PlanReviewer = ko.observable($('<div/>').html(item.PlanReviewer).text());
                self.CreatedByUser = ko.observable($('<div/>').html(item.CreatedByUser).text());
                self.CreatedDate = ko.observable($('<div/>').html(item.CreatedDate).text());
                self.Status = ko.observable($('<div/>').html(item.Status).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ActionPlanModel() method in ActionPlanManagement.js';
                logger.logMessage(msg);
            }
        }

    });
